import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { ROOT, RAC_LOYALTY_REWARDS_CONFIRMATION } from 'constants/routeConstants';
import useReferrerParam from 'hooks/useReferrerParam';
import BackButton from 'shared/components/BackButton/BackButton';
import Logo from './Logo';
import styles from './LoyaltyRewardsView.module.scss';

const LoyaltyRewardsView = () => {
  const { journeyError } = useSelector((state) => state.journeys.loyaltyRewards);

  // Flag to indicate referral from App (Webview)
  const isAppView = useReferrerParam();
  const navigate = useNavigate();
  const location = useLocation();
  const isConfirmationScreen = location.pathname === RAC_LOYALTY_REWARDS_CONFIRMATION;

  const onBackClick = async () => {
    navigate(ROOT);
  };

  return (
    <div>
      <style>{'body { background-color: #f1f1f1;'}</style>
      {!isAppView && <Logo />}
      {!isAppView && !isConfirmationScreen && (
        <div className={`${styles.backButtonContainer} ${journeyError ? styles.error : ''}`}>
          <BackButton onClickHandler={onBackClick} />
        </div>
      )}
      <div className={`${styles.journeyContainer} ${journeyError ? styles.error : ''}`}>
        <Outlet />
      </div>
    </div>
  );
};

export default LoyaltyRewardsView;
